<script lang="ts">
    import FormInput from "@components/forms/FormInput.svelte"
    import Icon from "./Icon.svelte"

    let visible = false
    export let value = ""
    export let autocomplete = "current-password"
</script>

<div class="eye-container">
    <FormInput
        class="password-input"
        placeholder="Password"
        type={visible ? "text" : "password"}
        {autocomplete}
        bind:value
    />
    <button
        type="button"
        class="eye-toggleable"
        aria-label={visible ? "Hide password" : "Show password"}
        on:click={() => (visible = !visible)}
    >
        <Icon icon="eyeToggle" toggled={!visible} />
    </button>
</div>

<style>
    .eye-container {
        position: relative;
    }

    .eye-container :global(.password-input) {
        padding-right: 2.8rem;
    }

    .eye-toggleable {
        appearance: none;
        display: grid;
        place-items: center;
        position: absolute;
        top: 50%;
        right: 0.7rem;
        width: 2rem;
        height: 2rem;
        border: 0;
        border-radius: 999px;
        background: transparent;
        color: var(--color-purple-700);
        cursor: pointer;
        padding: 0;
        transform: translateY(-50%);
    }

    .eye-toggleable:hover {
        background: var(--color-purple-50);
        color: var(--color-purple-800);
    }

    .eye-toggleable:focus-visible {
        outline: 2px solid var(--color-gold-400);
        outline-offset: 2px;
    }

    .eye-toggleable :global(svg) {
        width: 1.15rem;
        height: 1.15rem;
    }

    :global(.darkmode) .eye-toggleable {
        color: var(--color-purple-200);
    }

    :global(.darkmode) .eye-toggleable:hover {
        background: var(--color-grey-800);
        color: var(--color-purple-100);
    }
</style>
